<template>
	<el-dialog v-dialogDrag title="添加朋友" :visible.sync="dialogVisible" width="320px" :before-close="onClose" 
		custom-class="add-friend-dialog">
		<div class="search-box" style="display: flex;align-items: center;">
			<el-input placeholder="输入用户名或昵称" class="input-with-select" v-model="searchText" size="small"
			@keyup.enter.native="onSearch()">
			<i class="el-icon-search el-input__icon" slot="prefix"></i>
		</el-input>
		<div @click="onSearch()" style="width: 56px;height: 30px;text-align: center;line-height: 32px;background: #027AFF ;border-radius: 4px;color: #fff;margin-left: 8px;">搜索</div>
		</div>
		<!-- <el-scrollbar style="height:400px">
			<div v-for="(user) in users" :key="user.id" v-show="user.id != $store.state.userStore.userInfo.id">
				<div class="item">
					<div class="avatar">
						<head-image :name="user.nickName" :url="user.headImage" :online="user.online"></head-image>
					</div>
					<div class="friend-info">
						<div class="nick-name">
							<div>{{ user.nickName }}</div>
							<div :class="user.online ? 'online-status  online' : 'online-status'">{{
								user.online ? "[在线]" :"[离线]"}}</div>
						</div>
						<div class="user-name">
							<div>用户名:{{ user.userName }}</div>
						</div>
					</div>
					<el-button type="success" size="mini" v-show="!isFriend(user.id)"
						@click="onAddFriend(user)">添加</el-button>
					<el-button type="info" size="mini" v-show="isFriend(user.id)" plain disabled>已添加</el-button>
				</div>
			</div>
		</el-scrollbar> -->
		<div class="search-result" style="height:400px">
			<div v-if="!users || users.length === 0" style="text-align: center; color: #999; margin-top: 40px;">
				暂无数据
			</div>
			<!-- {{ usernow }} -->
			<!-- 用户列表已注释
			<el-scrollbar style="height: 100%">
				<div v-for="user in users" :key="user.id" v-show="user.id != $store.state.userStore.userInfo.id" @click="usernow = user" :class="['item', {selected: usernow && usernow.id === user.id}]" style="cursor:pointer;">
					<div class="avatar">
						<head-image :name="user.nickName" :url="user.headImage" :online="user.online"></head-image>
					</div>
					<div class="friend-info">
						<div class="nick-name">
							<div>{{ user.nickName }}</div>
							<div :class="user.online ? 'online-status  online' : 'online-status'">{{ user.online ? "[在线]" :"[离线]"}}</div>
						</div>
						<div class="user-name">
							<div>用户名:{{ user.userName }}</div>
						</div>
					</div>
					<el-button type="success" size="mini" v-show="!isFriend(user.id)" @click.stop="onAddFriend(user)">添加</el-button>
					<el-button type="info" size="mini" v-show="isFriend(user.id)" plain disabled>已添加</el-button>
				</div>
			</el-scrollbar>
			-->
			<el-container class="container" v-if="usernow && usernow.id">
				<!-- <div class="header">
					{{ usernow.nickName }}
				</div> -->
				<div>
					<div class="friend-info friend-info-center" style=" background-color: #FFFFFF !important;margin-top: 16px;border-radius: 4px;">
						<head-image :size="100" :name="usernow.nickName" :url="usernow.headImage" radius="10%" @click.native="showFullImage()"></head-image>
						<div>
							<div class="real-info" style="margin-top: 16px;border-bottom: 1px solid #D9DCE0 ;padding-bottom: 20px;margin-bottom: 24px;">
								<p style="width: 300px;margin: 0 auto;text-align: left;font-size: 18px;line-height: 28px;font-weight: 600;margin-bottom: 8px;">{{ usernow.nickName }}</p>
								<p style="width: 300px;margin: 0 auto;font-weight: 600;text-align: left;display: flex; align-items: center;font-size: 14px;">
									<img src="@/assets/image/icon_company 1@2x.png" style="width: 18px;height: 18px;margin-right: 4px;" alt="">{{ usernow.orgName || "暂无"}}</p>
							</div>
							<div class="btn-group" style="padding: 0 0 16px 0;">
								<!-- <div class="send-msg-btn" @click="onSendMessage(usernow)">
									<img src="@/assets/image/icon_messages2@2x.png" alt="" style="width: 24px;height: 24px;">
									<span>发消息</span>
								</div> -->
								<div style="width: 132px;height: 32px;text-align: center; line-height: 32px;background: #027AFF ;border-radius: 4px;color: #fff;" @click="onAddFriend(usernow)">
									添加好友
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-container>
		</div>
	</el-dialog>
</template>

<script>
import HeadImage from '../common/HeadImage.vue'


export default {
	name: "addFriend",
	components: { HeadImage },
	data() {
		return {
			users: [],
			searchText: "",
			usernow:{}
		}
	},
	props: {
		dialogVisible: {
			type: Boolean
		}
	},
	methods: {
		onClose() {
			this.$emit("close");
		},
		onSearch() {
			if (!this.searchText) {
				this.users = [];
				this.usernow = {};
				return;
			}
			this.$http({
				url: "/user/findByName",
				method: "get",
				params: {
					name: this.searchText
				}
			}).then((data) => {
				this.users = data;
				this.usernow = data[0] || {};
			})
		},
		onAddFriend(user) {
			this.$http({
				url: "/friend/add",
				method: "post",
				params: {
					friendId: user.id
				}
			}).then(() => {
				this.$message.success("添加成功，对方已成为您的好友");
				let friend = {
					id: user.id,
					nickName: user.nickName,
					headImage: user.headImage,
					online: user.online,
					deleted: false
				}
				this.$store.commit("addFriend", friend);
			})
		},
		isFriend(userId) {
			return this.$store.getters.isFriend(userId);
		}
	}
}
</script>

<style lang="scss" scoped>
.add-friend {
  background-color: #F3F3F3 !important;
}
::v-deep .el-dialog{
	margin-top: 0!important;
	position: absolute;
	left: 50%;
	top:50% ;
	transform: translate(-50%,-50%);
}
::v-deep .el-dialog__body {
  background-color: #F3F3F3  !important;
  border-radius: 0 0 4px 4px !important;
  height: 380px;
}
::v-deep .el-dialog__header {
  background-color: #F3F3F3  !important;
  border-radius: 4px 4px 0 0 !important;
}
::v-deep .input-with-select .el-input__inner {
  padding-left: 30px !important;
  padding-right: 10px !important;
  background-color: white!important;
}
.add-friend,.el-dialog ::v-deep{
	.el-input.input-with-select.el-input--small {
		.el-input__inner {
			padding-left: 30px !important;
			padding-right: 10px !important;
			background-color: white!important;
		}
	}
	.item {
		height: 65px;
		display: flex;
		position: relative;
		padding-left: 15px;
		align-items: center;
		padding-right: 25px;
		.friend-info {
			margin-left: 15px;
			flex: 3;
			display: flex;
			flex-direction: column;
			flex-shrink: 0;
			overflow: hidden;
			.nick-name {
				display: flex;
				flex-direction: row;
				font-weight: 600;
				font-size: 16px;
				line-height: 25px;
				.online-status {
					font-size: 12px;
					font-weight: 600;
					&.online {
						color: #5fb878;
					}
				}
			}
			.user-name {
				display: flex;
				flex-direction: row;
				font-size: 12px;
				line-height: 20px;
			}
		}
	}
}
::v-deep .el-dialog__headerbtn .el-dialog__close {

}
::v-deep .el-dialog__headerbtn:hover .el-dialog__close {
  color: #027aff !important;
}
</style>
